import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { toast } from "react-toastify";
import { EyeIcon, HeartIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { uuid } from "uuidv4";

import { store as saleSupport } from "../../../../components/VerticalLayout/store";
import store, {
    setIsHistoryShopsModalOpened,
    setNumberActiveMultiShop,
    setNumberArchiveMultiShop,
    setSaleSupportToBeArchived,
    setSelectedHistorySaleSupports,
    setSelectedSaleSupports,
    setIsLoading,
    setKey,
} from "../store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";

import { ConfirmationArchive } from "../ConfirmationArchive";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import ErrorToast from "@components/Common/ErrorTost";
import { ID_SALE_SUPPORT_KIOSK, TOAST_LIMIT_DEFAULT } from "@constants/index";
import { generalConfigStore, setItemsDisable } from "@store";
import { useFetchGlobal } from "../../../../api/hooks";
import { showSuccessToast } from "@components/Common/SuccessToast";

export function CustomIcons({
    selectedRowData,
    isArchivedSaleSupportClicked,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const {
        numberActiveMultiShop,
        numberArchiveMultiShop,
        isHistoryShopsModalOpened,
        saleSupportData,
        shopsSaleSupportData,
        saleSupportToBeArchived,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, userID, operatorID } = useSnapshot(saleSupport);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [saleSupportState, setSaleSupportState] = React.useState<boolean>(
        selectedRowData.selectedRow?.isActive
            ? selectedRowData.selectedRow?.isActive
            : false
    );
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [isArchiveSVModalOpened, setIsArchiveSVModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");

    async function ClickEventEdit() {
        const shopId = selectedRowData.selectedRow.shopId;
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/modif-all-app-state`;

        try {
            const payload = {
                franchiseId: franchiseID,
                shopId,
                state: !selectedRowData?.selectedRow.isActive,
            };

            const data = await fetchGlobal<any>(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (data.error) {
                throw new Error("Error in application status!");
            }
        } catch (e: any) {
            toast.error(`${t("There's an error")!}`);
        }
    }

    async function handleStateChange(isActive: boolean) {
        setLimit(TOAST_LIMIT_DEFAULT);
        setIsLoading(true);

        const id = selectedRowData?.selectedRow.Id;
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;

        const payload = [
            {
                userId: userID,
                shopId: [selectedRowData?.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [id]: {
                        id,
                        displayName:
                            selectedRowData?.selectedRow[t("Display name")],
                        tag: selectedRowData?.selectedRow.Tag,
                        support_de_vente:
                            selectedRowData?.selectedRow[t("Sale support")],
                        shopId: selectedRowData?.selectedRow.shopId,
                        isArchived: selectedRowData?.selectedRow.isArchived,
                        isActive,
                        isFavorite: selectedRowData.selectedRow.isFavorite,
                        advancedDisplayName:
                            selectedRowData.selectedRow.advancedDisplayName,
                    },
                },
            },
        ];

        try {
            const result = await fetchGlobal<any>(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (result.error) {
                throw new Error(
                    result.message || "Error while updating sale support state"
                );
            }
            showSuccessToast(
                isActive
                    ? `${t("Sale support has been successfully activated")}`
                    : `${t("Sale support has been successfully deactivated")}`
            );

            if (selectedRowData.selectedRow.Id === ID_SALE_SUPPORT_KIOSK) {
                await ClickEventEdit();

                if (isActive === false) {
                    const isAlreadyDisabled = itemsDisable.some(
                        (item: any) =>
                            item.id === selectedRowData.selectedRow.Id &&
                            item.shopId === selectedRowData.selectedRow.shopId
                    );

                    if (!isAlreadyDisabled) {
                        const updated = [
                            ...itemsDisable,
                            {
                                id: selectedRowData.selectedRow.Id,
                                state: false,
                                shopId: selectedRowData.selectedRow.shopId,
                            },
                        ];
                        setItemsDisable(updated);
                        localStorage.setItem(
                            "itemsDisable",
                            JSON.stringify(updated)
                        );
                    }
                } else {
                    const updated = itemsDisable.filter(
                        (item: any) =>
                            !(
                                item.id === selectedRowData.selectedRow.Id &&
                                item.shopId ===
                                    selectedRowData.selectedRow.shopId
                            )
                    );
                    setItemsDisable(updated);
                    localStorage.setItem(
                        "itemsDisable",
                        JSON.stringify(updated)
                    );
                }
            }

            setKey(uuid());
            setIsLoading(false);
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
        }
    }

    async function handleActiveSaleSupport(selectedRowData: any) {
        setIsLoading(true);
        toast.dismiss();
        setLimit(TOAST_LIMIT_DEFAULT);

        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;

        const payload = [
            {
                userId: userID,
                shopId: [selectedRowData.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isShop: true,
                data: {
                    [selectedRowData.selectedRow.Id]: {
                        id: selectedRowData.selectedRow.Id,
                        displayName:
                            selectedRowData?.selectedRow[t("Display name")],
                        tag: selectedRowData?.selectedRow.Tag,
                        support_de_vente:
                            selectedRowData?.selectedRow[t("Sale support")],
                        shopId: selectedRowData?.selectedRow.shopId,
                        isActive: selectedRowData.selectedRow.isActive,
                        isArchived: false,
                        isFavorite: selectedRowData.selectedRow.isFavorite,
                        advancedDisplayName:
                            selectedRowData.selectedRow.advancedDisplayName,
                    },
                },
            },
        ];

        try {
            const data = await fetchGlobal<any>(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (data.error) throw new Error("Error unarchiving sale support");
            showSuccessToast(
                `${t("Sale support is successfully unarchived")!}`
            );

            setKey(uuid());
            setNumberActiveMultiShop(numberActiveMultiShop + 1);
            setNumberArchiveMultiShop(numberArchiveMultiShop - 1);
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
        } finally {
            setIsLoading(false);
        }
    }

    async function handleArchiveSaleSupport(selectedRowData: any) {
        setLimit(TOAST_LIMIT_DEFAULT);
        setIsLoading(true);

        try {
            const listOfSaleSupport = encodeURIComponent(selectedRowData.Id);
            const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/isSaleSupportUsed?userId=${userID}&shopId=${selectedRowData?.shopId}&franchiseId=${franchiseID}&saleSupport=${listOfSaleSupport}`;

            const result = await fetchGlobal<any>(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (result.error) throw new Error(result.message);

            if (result.saleSupportUsed.length > 0) {
                ErrorToast(
                    `${t("Attention, you cannot archive a used element.")}`
                );
                setIsLoading(false);
                return;
            }

            setIsArchiveSVModalOpened(true);
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        } finally {
            setIsLoading(false);
        }
    }

    async function handleArchiveSaleSupportShop(selectedRowData: any) {
        setIsLoading(true);
        setLimit(TOAST_LIMIT_DEFAULT);

        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;

        const payload = [
            {
                userId: userID,
                shopId: [selectedRowData?.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [selectedRowData?.Id]: {
                        id: selectedRowData.Id,
                        displayName: selectedRowData[t("Display name")],
                        tag: selectedRowData.Tag,
                        support_de_vente: selectedRowData[t("Sale support")],
                        shopId: selectedRowData.shopId,
                        isActive: false,
                        isArchived: true,
                        isFavorite: selectedRowData.isFavorite,
                        advancedDisplayName:
                            selectedRowData.advancedDisplayName,
                    },
                },
            },
        ];

        try {
            const result = await fetchGlobal<any>(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (result.error) throw new Error(result.message);
            showSuccessToast(`${t("Sale Support is successfully archived")}`);
            setKey(uuid());
            setNumberActiveMultiShop(numberActiveMultiShop - 1);
            setNumberArchiveMultiShop(numberArchiveMultiShop + 1);
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        } finally {
            setIsLoading(false);
        }
    }

    async function favoriteSaleSupport() {
        setIsLoading(true);
        setLimit(TOAST_LIMIT_DEFAULT);
        toast.dismiss();

        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
        const dataSS: any[] = [];

        const clickedId = selectedRowData.selectedRow.Id;
        const clickedShopId = selectedRowData.selectedRow.shopId;
        let clickedIsFavorite = false;

        shopsSaleSupportData.forEach((el: any) => {
            el.subRows.forEach((saleSupport: any) => {
                if (
                    saleSupport.Id === clickedId &&
                    saleSupport.shopId === clickedShopId
                ) {
                    clickedIsFavorite = saleSupport.isFavorite;
                }
            });
        });

        shopsSaleSupportData.forEach((el: any) => {
            el.subRows.forEach((saleSupport: any) => {
                if (saleSupport.shopId !== clickedShopId) return;

                const isClicked =
                    saleSupport.Id === clickedId &&
                    saleSupport.shopId === clickedShopId;

                dataSS.push({
                    userId: userID,
                    shopId: [clickedShopId],
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    isShop: false,
                    data: {
                        [saleSupport.Id]: {
                            id: saleSupport.Id,
                            displayName: saleSupport[t("Display name")],
                            tag: saleSupport.Tag,
                            support_de_vente: saleSupport[t("Sale support")],
                            shopId: saleSupport.shopId,
                            isActive: saleSupport.isActive,
                            isArchived: saleSupport.isArchived,
                            // ✅ toggle only clicked one
                            isFavorite: isClicked ? !clickedIsFavorite : false,
                            advancedDisplayName:
                                saleSupport.advancedDisplayName,
                        },
                    },
                });
            });
        });

        try {
            const data = await fetchGlobal<any>(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataSS),
            });

            if (data.error) throw new Error("Error updating favorite state");

            showSuccessToast(
                `${t("Favorite state has been enabled successfully")}`
            );
            setKey(uuid());
        } catch (error) {
            ErrorToast(t("There's an error"));
        } finally {
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        if (isValidateClicked === true) {
            handleArchiveSaleSupportShop(saleSupportToBeArchived);
        }
        // eslint-disable-next-line
    }, [isValidateClicked]);

    return (
        <React.Fragment>
            {selectedRowData.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isArchivedSaleSupportClicked
                                        ? ""
                                        : selectedRowData.selectedRow
                                              .isFavorite === false
                                        ? t("Enable favorite state")
                                        : t("Disable favorite state")
                                }
                            >
                                <div>
                                    <HeartIcon
                                        onClick={() => {
                                            if (
                                                selectedRowData.selectedRow
                                                    .isFavorite === false
                                            ) {
                                                if (
                                                    selectedRowData.selectedRow
                                                        .isActive === false
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Please note, you cannot activate the favorite state for a disabled sale support"
                                                        )
                                                    );
                                                } else {
                                                    favoriteSaleSupport();
                                                }
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        name="heart"
                                        fill={
                                            selectedRowData.selectedRow
                                                .isFavorite
                                                ? "red"
                                                : "black"
                                        }
                                        className={`${classnames(
                                            "pointer__clz",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedSaleSupportClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={
                                    isArchivedSaleSupportClicked
                                        ? ""
                                        : saleSupportState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={saleSupportState}
                                        onChange={async (e: boolean) => {
                                            if (
                                                selectedRowData.selectedRow
                                                    .isFavorite &&
                                                selectedRowData.selectedRow
                                                    .isActive
                                            ) {
                                                ErrorToast(
                                                    t(
                                                        "Please note, you cannot deactivate a favorite sale support"
                                                    )
                                                );
                                            } else {
                                                setMessage(
                                                    saleSupportState
                                                        ? t(
                                                              "Caution, the Sale support may be used by other modules.\n Would you like to confirm the deactivation of the selected Sale support?"
                                                          )
                                                        : t(
                                                              "Would you like to confirm the activation of the selected Sale support?"
                                                          )
                                                );
                                                setYesFunction(() => {
                                                    setSaleSupportState(
                                                        !saleSupportState
                                                    );
                                                    handleStateChange(e);
                                                });

                                                setActivationDeactivationMessageModalOpened(
                                                    true
                                                );
                                            }
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "pointer__clz ml-1 cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedSaleSupportClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>

                            {!isArchivedSaleSupportClicked ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={() => {
                                                if (
                                                    selectedRowData.selectedRow
                                                        ?.isFavorite === true
                                                ) {
                                                    setIsLoading(false);
                                                    ErrorToast(
                                                        t(
                                                            `Please note, you cannot archive a favorite sales support`
                                                        )
                                                    );
                                                } else {
                                                    setSaleSupportToBeArchived(
                                                        selectedRowData.selectedRow
                                                    );
                                                    handleArchiveSaleSupport(
                                                        selectedRowData?.selectedRow
                                                    );
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "ml-1 cmn_icn_BTarchived",
                                                {
                                                    "not-allowed-icon__clz": isLoading,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        saleSupportData.find(
                                            (el: any) =>
                                                el.Id ===
                                                selectedRowData.selectedRow.Id
                                        ) !== undefined
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                handleActiveSaleSupport(
                                                    selectedRowData
                                                );
                                            }}
                                            className={`${classnames(
                                                "pointer__clz ml-1 cmn_icn_BTunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isLoading ||
                                                        saleSupportData.find(
                                                            (el: any) =>
                                                                el.Id ===
                                                                selectedRowData
                                                                    .selectedRow
                                                                    .Id
                                                        ) !== undefined,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                className="pointer__clz ml-1 cmn_icn_BThistory"
                                onClick={() => {
                                    setIsHistoryShopsModalOpened(
                                        !isHistoryShopsModalOpened
                                    );
                                    setSelectedHistorySaleSupports(
                                        selectedRowData.selectedRow
                                    );
                                    setSelectedSaleSupports([
                                        {
                                            [selectedRowData.selectedRow
                                                .shopId]:
                                                selectedRowData.selectedRow.Id,
                                        },
                                    ]);
                                }}
                                height={25}
                                width={25}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
            {isArchiveSVModalOpened ? (
                <ConfirmationArchive
                    isArchiveSVModalOpened={isArchiveSVModalOpened}
                    setIsArchiveSVModalOpened={setIsArchiveSVModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </React.Fragment>
    );
}
